import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';
export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const add = geo.createNode('add');

	// let's add a material so we can actually see the point
	const materials = root.createNode('materialsNetwork');
	const points = materials.createNode('points');
	points.p.color.set([0, 0, 1]);
	// assign the material
	const material = geo.createNode('material');
	material.setInput(0, add);
	material.p.material.setNode(points);
	material.flags.display.set(true);

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [add],
		autoLayout: true,
	};
}
// export const sopAdd = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/add/Create Points`,
// 		createData,
// 		relatedNodes: [AddSopNode],
// 	}),
// ];
